import * as Api from '@ViewModels';
import produce from 'immer';
import { useCallback } from 'react';
import {
	EStatusOption,
	StatusFilterCheckboxesMap,
	findMatchingStatus,
} from '../../../../components/AdvancedFilters/hooks/statusFilterOptions';

export { EStatusOption, StatusFilterCheckboxesMap };

export const useStatusFilters = ({
	filter,
	onChangeFilter,
}: {
	filter: Api.IBulkContactsRequest;
	onChangeFilter: (filter: Api.IBulkContactsRequest) => void;
}) => {
	const selectedStatuses: EStatusOption[] = filter.filter.criteria
		.filter(criterion => {
			const match = findMatchingStatus(criterion);
			return !!match;
		})
		.map(criterion => {
			const key = findMatchingStatus(criterion)[0];
			return parseInt(key, 10) as EStatusOption;
		});

	const isArchived = useCallback(() => {
		return !!filter.filter.criteria.find(x => x.property === Api.ContactFilterCriteriaProperty.Archived);
	}, [filter]);

	const getStatusCriteria = (_selectedStatuses: EStatusOption[]) => {
		return _selectedStatuses.map(statusOption => StatusFilterCheckboxesMap[statusOption].criteria);
	};

	const toggleStatusFilter = (statusOption: EStatusOption) => {
		const nextFilter = produce(filter, draftFilter => {
			if (selectedStatuses.indexOf(statusOption) > -1) {
				const criteriaToRemove = StatusFilterCheckboxesMap[statusOption].criteria;
				const match = draftFilter.filter.criteria.find(criterion => {
					return (
						criterion.property === criteriaToRemove.property &&
						criterion.op === criteriaToRemove.op &&
						criterion.value === criteriaToRemove.value
					);
				});
				const index = match !== undefined ? draftFilter.filter.criteria.indexOf(match) : -1;
				if (index > -1) {
					draftFilter.filter.criteria.splice(index, 1);
				}
			} else {
				const match = StatusFilterCheckboxesMap[statusOption];
				draftFilter.filter.criteria.push(match.criteria);
			}
		});

		onChangeFilter(nextFilter);
	};

	return {
		getStatusCriteria,
		isArchived,
		selectedStatuses,
		toggleStatusFilter,
	};
};
